import { QueryFilter } from "model/essential-types";
import { MapZonesQueryFilter } from '../map-zones';

export class MapZonesFilter implements QueryFilter, MapZonesQueryFilter {
  constructor(public text: string = null, public includeArchived: boolean = false) { }

  canClear(hint?: any) {
    return this.text != null || this.includeArchived === true;
  }

  clear(hint?: any) {
    this.text = null;
    this.includeArchived = false;
  }
}
